<div class="action-menu">
   <button *ngIf="( versionUpdate.state$ | async ) === 'minimized'" type="button" class="update-pill"
      (click)="versionUpdate.open()">
      <span class="update-pill-dot" aria-hidden="true"></span>
      <mat-icon aria-hidden="true">refresh</mat-icon>
      Update ready
   </button>

   <ng-container *ngIf="userService.user | async">
      <lib-menu-help></lib-menu-help>

      <lib-quick-reports *ngIf="access.hasAccess( 'tracking' ) | async"></lib-quick-reports>

      <lib-theme-switcher></lib-theme-switcher>

      <lib-menu-settings></lib-menu-settings>

      <lib-notifications></lib-notifications>
   </ng-container>

   <lib-user-menu></lib-user-menu>
</div>
